// src/pages/Terms.jsx
// Terms of Use page

import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function Terms({ theme, toggleTheme }) {
  return (
    <div className="legal-page">
      <header className="legal__header">
        <div className="container legal__header-inner">
          <Link to="/" className="legal__brand">
            <img src="/logo-full.png" alt="BrainAxis" className="legal__logo" />
          </Link>
          <button
            className="legal__theme"
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            {theme === 'dark' ? '☀' : '☾'}
          </button>
        </div>
      </header>

      <main className="legal__main">
        <div className="container">
          <article className="legal__content">
            <h1>Terms of Use</h1>
            <p className="legal__updated">Last updated: September 2026</p>

            <p>
              These terms govern your use of the BrainAxis website and research platform, 
              operated by BrainAxis Pty Ltd (ACN 696 339 947).
            </p>

            <h2>Research use only</h2>
            
            <p>
              The BrainAxis platform and all analysis outputs are provided for research 
              purposes only. They are not a medical device, are not intended for the 
              diagnosis, treatment, cure or prevention of any disease, and must not be 
              used to inform clinical decisions about individual patients. No output 
              should be relied upon as medical advice.
            </p>

            <h2>Access</h2>
            
            <p>
              Platform access is by invitation. You are responsible for keeping your 
              credentials secure and for all activity under your account. We may suspend 
              or withdraw access at any time.
            </p>

            <h2>Data you upload</h2>
            
            <p>
              You must not upload identifiable patient information. You are responsible 
              for ensuring that any data you upload has been de-identified, and that you 
              have the necessary rights, approvals and ethics clearances to upload and 
              analyse it. You retain ownership of data you upload. You grant us permission 
              to process it for the purpose of providing the analysis you have requested.
            </p>

            <h2>Intellectual property</h2>
            
            <p>
              All software, models, methods and content provided by BrainAxis remain our 
              property or that of our licensors. You may not copy, reverse engineer or 
              redistribute them.
            </p>

            <h2>No warranty</h2>
            
            <p>
              The platform is provided "as is". We make no warranty that outputs will be 
              accurate, complete or fit for any particular purpose, and we do not warrant 
              uninterrupted availability.
            </p>

            <h2>Limitation of liability</h2>
            
            <p>
              To the maximum extent permitted by law, BrainAxis is not liable for any 
              indirect or consequential loss arising from use of the platform. Nothing 
              in these terms excludes rights under the Australian Consumer Law that 
              cannot lawfully be excluded.
            </p>

            <h2>Governing law</h2>
            
            <p>
              These terms are governed by the laws of Victoria, Australia.
            </p>

            <h2>Contact</h2>
            
            <address>
              Please use the <Link to="/#contact">contact form</Link> on our website.
            </address>
          </article>

          <div className="legal__back">
            <Link to="/">← Back to home</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
